import { authActions } from "#redux/reducers/authReducer";
import { createAppAsyncThunk } from "#redux/store";
import { API } from "#utils";

export const logout = createAppAsyncThunk(
  "auth/LOGOUT",
  (_, { dispatch }) => {
    dispatch(authActions.clearData());
  }
);

export const loadUserData = createAppAsyncThunk(
  "auth/LOAD_USER_DATA",
  (_, { dispatch }) => {
    dispatch(authActions.setReady(false));
    API
      .get("/accounts/user/")
      .then((res) => {
        dispatch(authActions.loadUser({
          is_logged: true,
          user: res.data,
        }));
        dispatch(authActions.setReady(true));
      })
      .catch(() => {
        dispatch(authActions.clearData);
        dispatch(authActions.setReady(true));
      });
  }
);
